'use client'

import dynamic from 'next/dynamic'
import { FC, ReactNode } from 'react'

export type Props = {
  children: ReactNode
}

const LenisLayoutLogic = dynamic(() => import('@/components/Layout/LenisLayout/LenisLayoutLogic'), {
  ssr: true,
})

const LenisLayout: FC<Props> = ({ children }) => {
  return <LenisLayoutLogic>{children}</LenisLayoutLogic>
}

export default LenisLayout
